import { LIST_ORDER_URL, CREATE_ORDER_URL, CHECK_ORDER_URL } from 'consts/api';
import services from './index';

class PremiumOrderServices {
  listOrder(filters) {
    return services.post(LIST_ORDER_URL, filters);
  }

  createOrder(body = { duration: '', volume: '', messageType: '' }) {
    return services.post(CREATE_ORDER_URL, body);
  }

  checkCredit({ duration = '', volume = '' }) {
    return services.post(CHECK_ORDER_URL, { duration, volume });
  }
}

export default new PremiumOrderServices();
